module.exports = __webpack_public_path__ + "static/media/benefits10.a2e3d996.webp";